import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { InsuranceStatusModel } from 'src/app/models/InsuranceDetailsModel';
import { AdminService } from 'src/app/services/admin.service';
import { GeneralService } from 'src/app/services/general.service';
import { LookUpService } from 'src/app/services/lookup.service';
import swal from 'sweetalert2';

@Component({
  selector: 'app-insurance-provider-view',
  templateUrl: './insurance-provider-view.component.html',
  styleUrls: ['./insurance-provider-view.component.css']
})
export class InsuranceProviderViewComponent {
  insuranceForm: FormGroup;
  insuranceStatus: InsuranceStatusModel[] = [];
  submittedInsForm : boolean = false;
  doSwitch:boolean=false;
  editUrl:any;
  canEdit : boolean = false;
  menuId:number = 0;
  id:number = 0;
  menuUrl : string = "";

  constructor(private fb: FormBuilder, private _lookupService: LookUpService,private adminService: AdminService,private router:Router
    ,private activatedRoute:ActivatedRoute,private generalService: GeneralService) {
      let obj = this.router.getCurrentNavigation()?.extras?.state;
      debugger;
      if(obj)
      {
        this.menuId = parseInt(obj['menuId'])??0;
        this.menuUrl = obj['menuUrl'];
        this.canEdit = obj['canEdit'];
        this.editUrl = obj['editUrl'];
        this.id = parseInt(obj['id']);
        this.getFormData(this.id);
      }
      this.insuranceForm = this.fb.group({
        "insuranceId": [''],
        "insuranceName": [''],
        "contactNumber": [''],
        "whatsAppNumber": [''],
        "email": [''],
        "address": [''],
        "insuranceStatus": [''],
        "createdDate":['']
      });

  }
  ngOnInit(): void {
  }

  toggleChanged(data:any){
    data.data.comment = data.comment;
    data.data.status = data.status;
    this.InsuranceProductStatusUpdate(data.data);
  }

  get insuranceFormControl() {
    return this.insuranceForm.controls;
  }

  async InsuranceProductStatusUpdate(data:any)
  {
    debugger;
      const res = await this.adminService.InsuranceProductStatusUpdate(data);    
      if (res != null && res.result && res.result.code == 1) {
        swal.fire({
          position: 'center',
          icon: 'success',
          title: res.result.message,
          showConfirmButton: false,
          timer: 3000,
        });
      }    
      else
      {
        swal.fire({
          position: 'center',
          icon: 'error',
          title: res.result.message,
          showConfirmButton: false,
          timer: 3000,
        });
      } 
  }
  numberOnly(event:any): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode >= 48 && charCode <= 57) {
      return true;
    }
    return false;
  }

  alphabetOnly(event:any): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if ((charCode >= 65 && charCode <= 90) || (charCode >= 97 && charCode <= 122)) {
      return true;
    }
    return false;
  }

  alphaNumericOnly(event:any): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if ((charCode >= 48 && charCode <= 57) || ((charCode >= 65 && charCode <= 90) || (charCode >= 97 && charCode <= 122))) {
      return true;
    }
    return false;
  }

  async getFormData(id:number)
  {
    const res = await this.adminService.GetInsuranceDetails(id); 
      if (res != null && res.result) {
        this.insuranceForm.patchValue(res.result.insuranceDetailsModel);
        this.insuranceStatus = res.result.insuranceStatusList;
        if(res.result.insuranceProductsPlan?.length > 0){
            const plans = res.result.insuranceProductsPlan;
            this.insuranceStatus.forEach((element:InsuranceStatusModel) => {
              element.insuranceProductsPlanListItemObj = plans.filter((p:any) => p.productId == element.productId).map((m:any)=> {return {name:m.planDescription, id:m.planID,checked:m.planStatus}});
            });
          }
      }    
      else
      {
        // swal.fire({
        //   position: 'center',
        //   icon: 'error',
        //   title: 'Something went wrong',
        //   showConfirmButton: false,
        //   timer: 3000,
        // });
      } 
  }

  backBtClick(){
    this.router.navigateByUrl(this.editUrl,{ state: { id:this.id, menuId : this.menuId, menuUrl : this.menuUrl, canEdit : this.canEdit, editUrl : this.editUrl }});
  }
  
  homeBtClick(){
    this.router.navigateByUrl(this.menuUrl,{ state: { menuId:this.menuId, menuUrl : this.menuUrl }});
  }

  onInsuranceCopanyPlanSelect(){
  //onInsuranceCopanyPlanSelect(data:Item[], productId:number){  
  //     let selectedIds = data.map((m:Item)=>{return m.id});
  //     switch(productId){
  //       case 1 : this.carInsuranceProductsPlanList?.forEach((element:Item)=>{ element.checked = selectedIds?.includes(element.id) ? true : false; }); break;
  //       case 2 : this.bikeInsuranceProductsPlanList?.forEach((element:Item)=>{ element.checked = selectedIds?.includes(element.id) ? true : false; }); break;
  //       case 3 : this.CommInsuranceProductsPlanList?.forEach((element:Item)=>{ element.checked = selectedIds?.includes(element.id) ? true : false; }); break;
  //       case 4 : this.healthIndInsuranceProductsPlanList?.forEach((element:Item)=>{ element.checked = selectedIds?.includes(element.id) ? true : false; }); break;
  //       case 5 : this.healthFamilyInsuranceProductsPlanList?.forEach((element:Item)=>{ element.checked = selectedIds?.includes(element.id) ? true : false; }); break;
  //       case 6 : this.travelInsuranceProductsPlanList?.forEach((element:Item)=>{ element.checked = selectedIds?.includes(element.id) ? true : false; }); break;
  //       case 7 : this.homeInsuranceProductsPlanList?.forEach((element:Item)=>{ element.checked = selectedIds?.includes(element.id) ? true : false; }); break;
  //       case 8 : this.officeInsuranceProductsPlanList?.forEach((element:Item)=>{ element.checked = selectedIds?.includes(element.id) ? true : false; }); break;
  //       case 9 : this.shopInsuranceProductsPlanList?.forEach((element:Item)=>{ element.checked = selectedIds?.includes(element.id) ? true : false; }); break;
  //     }
  //   }
  
  //   async updatePlanConfiguration()
  //   {
  //     if(this.planConfigurationComment??"" != ""){    
  //       const ids = this.carInsuranceProductsPlanList?.filter((f:Item) => f.checked).map((m:Item)=> {return parseInt(m.id??"0")}).concat(
  //         this.bikeInsuranceProductsPlanList?.filter((f:Item) => f.checked).map((m:Item)=> {return parseInt(m.id??"0")}), 
  //         this.CommInsuranceProductsPlanList?.filter((f:Item) => f.checked).map((m:Item)=> {return parseInt(m.id??"0")}),
  //         this.healthIndInsuranceProductsPlanList?.filter((f:Item) => f.checked).map((m:Item)=> {return parseInt(m.id??"0")}),
  //         this.healthFamilyInsuranceProductsPlanList?.filter((f:Item) => f.checked).map((m:Item)=> {return parseInt(m.id??"0")}),
  //         this.travelInsuranceProductsPlanList?.filter((f:Item) => f.checked).map((m:Item)=> {return parseInt(m.id??"0")}),
  //         this.homeInsuranceProductsPlanList?.filter((f:Item) => f.checked).map((m:Item)=> {return parseInt(m.id??"0")}),
  //         this.officeInsuranceProductsPlanList?.filter((f:Item) => f.checked).map((m:Item)=> {return parseInt(m.id??"0")}),
  //         this.shopInsuranceProductsPlanList?.filter((f:Item) => f.checked).map((m:Item)=> {return parseInt(m.id??"0")})
  //       ).join(',');;
  
  //       let obj ={
  //         comment : this.planConfigurationComment,
  //         insuranceId: parseInt(this.insuranceFormControl['insuranceId'].value??"0"),
  //         Ids : ids
  //       };
  
  //       //alert(JSON.stringify(obj));
  //       const res = await this.adminService.updatePlanConfiguration(obj);    
  //       if (res != null && res.result) {
  //         swal.fire({
  //           position: 'center',
  //           icon: res.result.code == 1 ? 'success' : 'error',
  //           title: res.result.message,
  //           showConfirmButton: false,
  //           timer: 3000,
  //         });
  
  //         if(res.result.code == 1){
  //           this.homeBtClick();
  //         }
  //       }    
  //       else
  //       {
  //         swal.fire({
  //           position: 'center',
  //           icon: 'error',
  //           title: res.result.message,
  //           showConfirmButton: false,
  //           timer: 3000,
  //         });
  //       } 
  //     }
  }
}
